import { render, staticRenderFns } from "./AtualizarUsuario.vue?vue&type=template&id=2d5ce0bd&"
import script from "./AtualizarUsuario.vue?vue&type=script&lang=js&"
export * from "./AtualizarUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports